import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsCoreFieldsRoute: InvariantJiraRoute = {
	name: 'classic-project-settings-core-fields',
	path: '/jira/core/c/projects/:projectKey/settings/fields',
	exact: true,
};
